export default __webpack_public_path__ + "static/media/sofa-2-seat-1-back.844d6b62.png";